// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__DJnl4","modal":"Modal_modal__pbiHg"};